export default __webpack_public_path__ + "static/media/856611_348705808576582_1751212540_o.0cf6b763.jpg";